module.exports = __webpack_public_path__ + "img/快递公司选择.08544d1b.png";